import BaseSetup from '@/components/BaseSetup';

export type SharedPictoCardEmits = { (e: 'delete' | 'click', value: Picto): void };

export type SharedPictoCardProps = {
	closable?: boolean
	selected?: boolean
	selectable?: boolean
	marker?: boolean
	error?: boolean
	label?: boolean
	picto: Picto
	tag?: PictoType
	color?: string
};

export default class SharedPictoCardSetup extends BaseSetup {

	static readonly defaultProps = { tag: 'icon' as PictoType };

	private get computedTag () { return this.props.picto.type ?? this.props.tag }

	constructor (
		private props: SharedPictoCardProps,
		private emits: SharedPictoCardEmits,
	) {
		super();
	}

	handleClick () {
		if (typeof this.props.picto.callback === 'function') {
			this.props.picto.callback(this.props.picto);
		}
		this.emits('click', this.props.picto);
	}

}
